import React from "react";
import {
  foodCalculators,
} from "./ConstantsFoodCalculator";
function MainCalculatorsList() {
  let calculatorsList = foodCalculators;
  let calculatorName = "Calculatrices Alimentaires";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.filter(item => item.showMain).slice(0, 6).map((item, index) => (
            <li key={index}>
              <a href={item.link} className="item-link">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ textAlign: "center" }}>
          <a
            className="btn btn-success"
            style={{ width: "90%" }}
            href={"/fr/food-calculators/"}
          >
            Plus
          </a>
          <hr />
        </div>
         </div>
</div>
  );
}
export default MainCalculatorsList;
